import { render, staticRenderFns } from "./CmgLeaderboardPoints.vue?vue&type=template&id=014b5174&scoped=true&lang=pug"
import script from "./cmg-leaderboard-points.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-points.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardPoints.vue?vue&type=style&index=0&id=014b5174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014b5174",
  null
  
)

export default component.exports